import gql from 'graphql-tag';

export default gql`
  query DraftContentsForIntegration($_id: UUID!) {
    draftContentsForIntegration(_id: $_id) {
      _id
      name
      _created
      _createdBy {
        name
      }
    }
  }
`;
